class ScrollAnimation {
  constructor(props = {}) {
    const { delay, duration } = props;
    this.setUp = false;
    this.delay = delay || 0.3;
    this.durationPerAnimation = duration || 0.15;
    this.lookForByClassName = ['scrollAnimate'];
    this.animations = [
      'fadeIn',
      'fadeInDown',
      'fadeInLeft',
      'fadeInRight',
      'fadeInUp',
      'flipInX',
      'slideInUp',
      'slideInDown',
      'slideInLeft',
      'slideInRight',
      'zoomIn',
      'zoomInDown',
      'zoomInLeft',
      'zoomInRight',
      'zoomInUp',
    ];
    this.elements2Animate = [];
    this.observer = null;
  }

  getElements2Animate = () => {
    if (typeof document === 'undefined') return;

    const elements = [];
    this.lookForByClassName.forEach((className) => {
      const matchingElements = document.getElementsByClassName(className);
      for (let index = 0; index < matchingElements.length; index += 1) {
        const element = matchingElements.item(index);
        if (elements.indexOf(element) === -1) {
          elements.push(element);
        }
      }
    });

    this.elements2Animate = elements.filter(element => element.dataset.scrollAnimated !== 'true');
  };

  isVisible = (element) => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top <= viewportHeight * 0.95 && rect.bottom >= 0;
  };

  getRandomAnimation = () => {
    const index = Math.floor(Math.random() * this.animations.length);
    return this.animations[index] || 'fadeIn';
  };

  getAnimation = (classList) => {
    let animation = this.getRandomAnimation();
    classList.forEach((className) => {
      if (className.indexOf('scrollAnimate:') === 0) {
        const requestedAnimation = className.split(':')[1];
        if (requestedAnimation && this.animations.includes(requestedAnimation)) {
          animation = requestedAnimation;
        } else if (requestedAnimation && document.styleSheets) {
          // Keep support for the legacy WC animations defined by this site.
          animation = requestedAnimation;
        }
      }
    });
    return animation;
  };

  setAnimations = () => {
    if (typeof window === 'undefined') return;

    this.getElements2Animate();
    let delaySum = this.delay;
    const visibleElements = [];

    this.elements2Animate.forEach((element) => {
      if (!this.isVisible(element)) return;

      const animation = this.getAnimation(Array.from(element.classList));
      element.dataset.scrollAnimated = 'true';
      element.classList.add(animation);
      element.style.animationDuration = `${this.durationPerAnimation}s`;
      element.style.webkitAnimationDuration = `${this.durationPerAnimation}s`;
      element.style.animationDelay = `${delaySum}s`;
      element.style.webkitAnimationDelay = `${delaySum}s`;
      delaySum += this.delay;
      visibleElements.push(element);
    });

    if (visibleElements.length) {
      this.elements2Animate = this.elements2Animate.filter(
        element => !visibleElements.includes(element),
      );
    }
  };

  refresh = () => {
    this.getElements2Animate();
    this.setAnimations();
  };

  init = () => {
    if (this.setUp || typeof window === 'undefined') return;

    this.setUp = true;
    this.refresh();
    window.addEventListener('scroll', this.setAnimations, { passive: true });
    window.addEventListener('resize', this.refresh);

    if (typeof MutationObserver !== 'undefined' && document.body) {
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  destroy = () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.setAnimations);
      window.removeEventListener('resize', this.refresh);
    }
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.setUp = false;
  };
}

export default ScrollAnimation;
